/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { EmployeesMercerStandingsCreateMercerStandingCommentModel } from '@coin/shared/core/util-models';
import { EmployeesMercerStandingsMercerStandingCommentModel } from '@coin/shared/core/util-models';
import { EmployeesMercerStandingsMercerStandingDashboardValuesModel } from '@coin/shared/core/util-models';
import { EmployeesMercerStandingsMercerStandingDetailsModel } from '@coin/shared/core/util-models';
import { EmployeesMercerStandingsUpdateMercerStandingModel } from '@coin/shared/core/util-models';
import { EmployeesMercerStandingsValidationMercerStandingValidationResponseModel } from '@coin/shared/core/util-models';
import { EmployeesMercerStandingsValidationValidateMercerStandingInputModel } from '@coin/shared/core/util-models';
import { SeasonsExportCreateExportModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmployeesMercerStandingsMercerStandingEmployeeDataModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSystemString } from '@coin/shared/core/util-models';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models';

import { CustomHttpParameterCodec } from '../encoder';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

export interface MercerStandingPartnerServiceCreateMercerStandingCommentsRequestParams {
  /** The unique id of the employee to create a comment for. */
  employeeId: string;
  /** The model data to create the comment with. */
  employeesMercerStandingsCreateMercerStandingCommentModel?: EmployeesMercerStandingsCreateMercerStandingCommentModel;
}

export interface MercerStandingPartnerServiceExportMercerStandingsPartnerRequestParams {
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
  search?: string;
  firstname?: string;
  lastname?: string;
  isHead?: Array<boolean>;
  gid?: Array<string>;
  orgCode?: Array<string>;
  orgCodeStartsWith?: string;
  country?: Array<string>;
  are?: Array<string>;
  orgLevel?: Array<string>;
  orgSize?: Array<number>;
  positionClass?: Array<number>;
  mercerJobCode?: Array<string>;
  mercerJobFamily?: Array<string>;
  mercerJobSubFamily?: Array<string>;
  mercerJobSpecialization?: Array<string>;
  lineManagerGid?: Array<string>;
  validationState?: Array<'Open' | 'RequestedHR' | 'RequestedCB' | 'Approved' | 'Rejected'>;
  wasPromoted?: Array<boolean>;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  seasonsExportCreateExportModel?: SeasonsExportCreateExportModel;
}

export interface MercerStandingPartnerServiceGetDashboardValuesMercerStandingsPartnerRequestParams {
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
  search?: string;
  firstname?: string;
  lastname?: string;
  isHead?: Array<boolean>;
  gid?: Array<string>;
  orgCode?: Array<string>;
  orgCodeStartsWith?: string;
  country?: Array<string>;
  are?: Array<string>;
  orgLevel?: Array<string>;
  orgSize?: Array<number>;
  positionClass?: Array<number>;
  mercerJobCode?: Array<string>;
  mercerJobFamily?: Array<string>;
  mercerJobSubFamily?: Array<string>;
  mercerJobSpecialization?: Array<string>;
  lineManagerGid?: Array<string>;
  validationState?: Array<'Open' | 'RequestedHR' | 'RequestedCB' | 'Approved' | 'Rejected'>;
  wasPromoted?: Array<boolean>;
}

export interface MercerStandingPartnerServiceGetForMeritMercerStandingsPartnerRequestParams {
  /**  */
  employeeId: string;
  /**  */
  seasonId: string;
}

export interface MercerStandingPartnerServiceGetMercerStandingsPartnerRequestParams {
  /**  */
  employeeId: string;
}

export interface MercerStandingPartnerServiceQueryFieldValuesMercerStandingsPartnerRequestParams {
  targetProperty: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
  search?: string;
  firstname?: string;
  lastname?: string;
  isHead?: boolean;
  gid?: Array<string>;
  orgCode?: Array<string>;
  orgCodeStartsWith?: string;
  country?: Array<string>;
  are?: Array<string>;
  orgLevel?: Array<string>;
  orgSize?: Array<number>;
  positionClass?: Array<number>;
  mercerJobCode?: Array<string>;
  mercerJobFamily?: Array<string>;
  mercerJobSubFamily?: Array<string>;
  mercerJobSpecialization?: Array<string>;
  lineManagerGid?: Array<string>;
  validationState?: Array<'Open' | 'RequestedHR' | 'RequestedCB' | 'Approved' | 'Rejected'>;
  page?: number;
  size?: number;
}

export interface MercerStandingPartnerServiceQueryMercerStandingCommentsRequestParams {
  /** The unique id of the employee to query comments for. */
  employeeId: string;
}

export interface MercerStandingPartnerServiceQueryMercerStandingsPartnerRequestParams {
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
  search?: string;
  firstname?: string;
  lastname?: string;
  isHead?: Array<boolean>;
  gid?: Array<string>;
  orgCode?: Array<string>;
  orgCodeStartsWith?: string;
  country?: Array<string>;
  are?: Array<string>;
  orgLevel?: Array<string>;
  orgSize?: Array<number>;
  positionClass?: Array<number>;
  mercerJobCode?: Array<string>;
  mercerJobFamily?: Array<string>;
  mercerJobSubFamily?: Array<string>;
  mercerJobSpecialization?: Array<string>;
  lineManagerGid?: Array<string>;
  validationState?: Array<'Open' | 'RequestedHR' | 'RequestedCB' | 'Approved' | 'Rejected'>;
  wasPromoted?: Array<boolean>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface MercerStandingPartnerServiceUpdateMercerStandingsPartnerRequestParams {
  /**  */
  employeeId: string;
  /**  */
  employeesMercerStandingsUpdateMercerStandingModel?: EmployeesMercerStandingsUpdateMercerStandingModel;
}

export interface MercerStandingPartnerServiceValidateMercerStandingsPartnerRequestParams {
  /**  */
  employeeId: string;
  /**  */
  employeesMercerStandingsValidationValidateMercerStandingInputModel?: EmployeesMercerStandingsValidationValidateMercerStandingInputModel;
}

/** @deprecated Use the equivalent from `@coin/shared/core/data-access-v2` instead. */
@Injectable({
  providedIn: 'root'
})
export class MercerStandingPartnerService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach(elem => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          k => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Creates a new employee comment for mercer standing.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createMercerStandingComments(
    requestParameters?: MercerStandingPartnerServiceCreateMercerStandingCommentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesMercerStandingsMercerStandingCommentModel>;
  public createMercerStandingComments(
    requestParameters?: MercerStandingPartnerServiceCreateMercerStandingCommentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesMercerStandingsMercerStandingCommentModel>>;
  public createMercerStandingComments(
    requestParameters?: MercerStandingPartnerServiceCreateMercerStandingCommentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesMercerStandingsMercerStandingCommentModel>>;
  public createMercerStandingComments(
    requestParameters?: MercerStandingPartnerServiceCreateMercerStandingCommentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error('Required parameter employeeId was null or undefined when calling createMercerStandingComments.');
    }
    const employeesMercerStandingsCreateMercerStandingCommentModel =
      requestParameters?.employeesMercerStandingsCreateMercerStandingCommentModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/mercer-standing/partner/api/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`;
    return this.httpClient.request<EmployeesMercerStandingsMercerStandingCommentModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employeesMercerStandingsCreateMercerStandingCommentModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceExportMercerStandingsPartnerRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceExportMercerStandingsPartnerRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceExportMercerStandingsPartnerRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceExportMercerStandingsPartnerRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    const search = requestParameters?.search;
    const firstname = requestParameters?.firstname;
    const lastname = requestParameters?.lastname;
    const isHead = requestParameters?.isHead;
    const gid = requestParameters?.gid;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const country = requestParameters?.country;
    const are = requestParameters?.are;
    const orgLevel = requestParameters?.orgLevel;
    const orgSize = requestParameters?.orgSize;
    const positionClass = requestParameters?.positionClass;
    const mercerJobCode = requestParameters?.mercerJobCode;
    const mercerJobFamily = requestParameters?.mercerJobFamily;
    const mercerJobSubFamily = requestParameters?.mercerJobSubFamily;
    const mercerJobSpecialization = requestParameters?.mercerJobSpecialization;
    const lineManagerGid = requestParameters?.lineManagerGid;
    const validationState = requestParameters?.validationState;
    const wasPromoted = requestParameters?.wasPromoted;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const seasonsExportCreateExportModel = requestParameters?.seasonsExportCreateExportModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (firstname !== undefined && firstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>firstname, 'Firstname');
    }
    if (lastname !== undefined && lastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>lastname, 'Lastname');
    }
    if (isHead) {
      isHead.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IsHead');
      });
    }
    if (gid) {
      gid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Gid');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (are) {
      are.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Are');
      });
    }
    if (orgLevel) {
      orgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgLevel');
      });
    }
    if (orgSize) {
      orgSize.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgSize');
      });
    }
    if (positionClass) {
      positionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionClass');
      });
    }
    if (mercerJobCode) {
      mercerJobCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobCode');
      });
    }
    if (mercerJobFamily) {
      mercerJobFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobFamily');
      });
    }
    if (mercerJobSubFamily) {
      mercerJobSubFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobSubFamily');
      });
    }
    if (mercerJobSpecialization) {
      mercerJobSpecialization.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'MercerJobSpecialization'
        );
      });
    }
    if (lineManagerGid) {
      lineManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LineManagerGid');
      });
    }
    if (validationState) {
      validationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ValidationState');
      });
    }
    if (wasPromoted) {
      wasPromoted.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WasPromoted');
      });
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/mercer-standing/partner/api/employees/export`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsExportCreateExportModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get values for the quick filters in the list view of standing position evaluation HR BP app
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDashboardValuesMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceGetDashboardValuesMercerStandingsPartnerRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesMercerStandingsMercerStandingDashboardValuesModel>;
  public getDashboardValuesMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceGetDashboardValuesMercerStandingsPartnerRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesMercerStandingsMercerStandingDashboardValuesModel>>;
  public getDashboardValuesMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceGetDashboardValuesMercerStandingsPartnerRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesMercerStandingsMercerStandingDashboardValuesModel>>;
  public getDashboardValuesMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceGetDashboardValuesMercerStandingsPartnerRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    const search = requestParameters?.search;
    const firstname = requestParameters?.firstname;
    const lastname = requestParameters?.lastname;
    const isHead = requestParameters?.isHead;
    const gid = requestParameters?.gid;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const country = requestParameters?.country;
    const are = requestParameters?.are;
    const orgLevel = requestParameters?.orgLevel;
    const orgSize = requestParameters?.orgSize;
    const positionClass = requestParameters?.positionClass;
    const mercerJobCode = requestParameters?.mercerJobCode;
    const mercerJobFamily = requestParameters?.mercerJobFamily;
    const mercerJobSubFamily = requestParameters?.mercerJobSubFamily;
    const mercerJobSpecialization = requestParameters?.mercerJobSpecialization;
    const lineManagerGid = requestParameters?.lineManagerGid;
    const validationState = requestParameters?.validationState;
    const wasPromoted = requestParameters?.wasPromoted;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (firstname !== undefined && firstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>firstname, 'Firstname');
    }
    if (lastname !== undefined && lastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>lastname, 'Lastname');
    }
    if (isHead) {
      isHead.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IsHead');
      });
    }
    if (gid) {
      gid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Gid');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (are) {
      are.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Are');
      });
    }
    if (orgLevel) {
      orgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgLevel');
      });
    }
    if (orgSize) {
      orgSize.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgSize');
      });
    }
    if (positionClass) {
      positionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionClass');
      });
    }
    if (mercerJobCode) {
      mercerJobCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobCode');
      });
    }
    if (mercerJobFamily) {
      mercerJobFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobFamily');
      });
    }
    if (mercerJobSubFamily) {
      mercerJobSubFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobSubFamily');
      });
    }
    if (mercerJobSpecialization) {
      mercerJobSpecialization.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'MercerJobSpecialization'
        );
      });
    }
    if (lineManagerGid) {
      lineManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LineManagerGid');
      });
    }
    if (validationState) {
      validationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ValidationState');
      });
    }
    if (wasPromoted) {
      wasPromoted.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WasPromoted');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/mercer-standing/partner/api/employees/dashboard`;
    return this.httpClient.request<EmployeesMercerStandingsMercerStandingDashboardValuesModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Returns MercerStanding for partner app of merit.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getForMeritMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceGetForMeritMercerStandingsPartnerRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesMercerStandingsMercerStandingDetailsModel>;
  public getForMeritMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceGetForMeritMercerStandingsPartnerRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesMercerStandingsMercerStandingDetailsModel>>;
  public getForMeritMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceGetForMeritMercerStandingsPartnerRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesMercerStandingsMercerStandingDetailsModel>>;
  public getForMeritMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceGetForMeritMercerStandingsPartnerRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error(
        'Required parameter employeeId was null or undefined when calling getForMeritMercerStandingsPartner.'
      );
    }
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling getForMeritMercerStandingsPartner.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/mercer-standing/partner/api/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmployeesMercerStandingsMercerStandingDetailsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Returns MercerStanding for partner app of standing position evaluation.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceGetMercerStandingsPartnerRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesMercerStandingsMercerStandingDetailsModel>;
  public getMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceGetMercerStandingsPartnerRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesMercerStandingsMercerStandingDetailsModel>>;
  public getMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceGetMercerStandingsPartnerRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesMercerStandingsMercerStandingDetailsModel>>;
  public getMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceGetMercerStandingsPartnerRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error('Required parameter employeeId was null or undefined when calling getMercerStandingsPartner.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/mercer-standing/partner/api/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmployeesMercerStandingsMercerStandingDetailsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries field values for the list view of standing position evaluation HR BP app
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceQueryFieldValuesMercerStandingsPartnerRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public queryFieldValuesMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceQueryFieldValuesMercerStandingsPartnerRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public queryFieldValuesMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceQueryFieldValuesMercerStandingsPartnerRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public queryFieldValuesMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceQueryFieldValuesMercerStandingsPartnerRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    if (targetProperty === null || targetProperty === undefined) {
      throw new Error(
        'Required parameter targetProperty was null or undefined when calling queryFieldValuesMercerStandingsPartner.'
      );
    }
    const search = requestParameters?.search;
    const firstname = requestParameters?.firstname;
    const lastname = requestParameters?.lastname;
    const isHead = requestParameters?.isHead;
    const gid = requestParameters?.gid;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const country = requestParameters?.country;
    const are = requestParameters?.are;
    const orgLevel = requestParameters?.orgLevel;
    const orgSize = requestParameters?.orgSize;
    const positionClass = requestParameters?.positionClass;
    const mercerJobCode = requestParameters?.mercerJobCode;
    const mercerJobFamily = requestParameters?.mercerJobFamily;
    const mercerJobSubFamily = requestParameters?.mercerJobSubFamily;
    const mercerJobSpecialization = requestParameters?.mercerJobSpecialization;
    const lineManagerGid = requestParameters?.lineManagerGid;
    const validationState = requestParameters?.validationState;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (firstname !== undefined && firstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>firstname, 'Firstname');
    }
    if (lastname !== undefined && lastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>lastname, 'Lastname');
    }
    if (isHead !== undefined && isHead !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isHead, 'IsHead');
    }
    if (gid) {
      gid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Gid');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (are) {
      are.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Are');
      });
    }
    if (orgLevel) {
      orgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgLevel');
      });
    }
    if (orgSize) {
      orgSize.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgSize');
      });
    }
    if (positionClass) {
      positionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionClass');
      });
    }
    if (mercerJobCode) {
      mercerJobCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobCode');
      });
    }
    if (mercerJobFamily) {
      mercerJobFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobFamily');
      });
    }
    if (mercerJobSubFamily) {
      mercerJobSubFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobSubFamily');
      });
    }
    if (mercerJobSpecialization) {
      mercerJobSpecialization.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'MercerJobSpecialization'
        );
      });
    }
    if (lineManagerGid) {
      lineManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LineManagerGid');
      });
    }
    if (validationState) {
      validationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ValidationState');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/mercer-standing/partner/api/employees/field-values`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets all comments made for this employee in mercerStanding context. This is not for a specific mercerStanding object but for the employee.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryMercerStandingComments(
    requestParameters?: MercerStandingPartnerServiceQueryMercerStandingCommentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<EmployeesMercerStandingsMercerStandingCommentModel>>;
  public queryMercerStandingComments(
    requestParameters?: MercerStandingPartnerServiceQueryMercerStandingCommentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<EmployeesMercerStandingsMercerStandingCommentModel>>>;
  public queryMercerStandingComments(
    requestParameters?: MercerStandingPartnerServiceQueryMercerStandingCommentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<EmployeesMercerStandingsMercerStandingCommentModel>>>;
  public queryMercerStandingComments(
    requestParameters?: MercerStandingPartnerServiceQueryMercerStandingCommentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error('Required parameter employeeId was null or undefined when calling queryMercerStandingComments.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/mercer-standing/partner/api/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`;
    return this.httpClient.request<Array<EmployeesMercerStandingsMercerStandingCommentModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Returns all employees with their LineManager and MercerStanding for the list view of standing position evaluation HR BP app.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceQueryMercerStandingsPartnerRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmployeesMercerStandingsMercerStandingEmployeeDataModel>;
  public queryMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceQueryMercerStandingsPartnerRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmployeesMercerStandingsMercerStandingEmployeeDataModel>>;
  public queryMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceQueryMercerStandingsPartnerRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmployeesMercerStandingsMercerStandingEmployeeDataModel>>;
  public queryMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceQueryMercerStandingsPartnerRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    const search = requestParameters?.search;
    const firstname = requestParameters?.firstname;
    const lastname = requestParameters?.lastname;
    const isHead = requestParameters?.isHead;
    const gid = requestParameters?.gid;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const country = requestParameters?.country;
    const are = requestParameters?.are;
    const orgLevel = requestParameters?.orgLevel;
    const orgSize = requestParameters?.orgSize;
    const positionClass = requestParameters?.positionClass;
    const mercerJobCode = requestParameters?.mercerJobCode;
    const mercerJobFamily = requestParameters?.mercerJobFamily;
    const mercerJobSubFamily = requestParameters?.mercerJobSubFamily;
    const mercerJobSpecialization = requestParameters?.mercerJobSpecialization;
    const lineManagerGid = requestParameters?.lineManagerGid;
    const validationState = requestParameters?.validationState;
    const wasPromoted = requestParameters?.wasPromoted;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (firstname !== undefined && firstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>firstname, 'Firstname');
    }
    if (lastname !== undefined && lastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>lastname, 'Lastname');
    }
    if (isHead) {
      isHead.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IsHead');
      });
    }
    if (gid) {
      gid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Gid');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (are) {
      are.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Are');
      });
    }
    if (orgLevel) {
      orgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgLevel');
      });
    }
    if (orgSize) {
      orgSize.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgSize');
      });
    }
    if (positionClass) {
      positionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionClass');
      });
    }
    if (mercerJobCode) {
      mercerJobCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobCode');
      });
    }
    if (mercerJobFamily) {
      mercerJobFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobFamily');
      });
    }
    if (mercerJobSubFamily) {
      mercerJobSubFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobSubFamily');
      });
    }
    if (mercerJobSpecialization) {
      mercerJobSpecialization.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'MercerJobSpecialization'
        );
      });
    }
    if (lineManagerGid) {
      lineManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LineManagerGid');
      });
    }
    if (validationState) {
      validationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ValidationState');
      });
    }
    if (wasPromoted) {
      wasPromoted.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WasPromoted');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/mercer-standing/partner/api/employees`;
    return this.httpClient.request<SharedPageModelOfEmployeesMercerStandingsMercerStandingEmployeeDataModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * &lt;p&gt;Update MercerStanding for partner app of standing position evaluation.&lt;/p&gt; &lt;p&gt;Only available for hr, c&amp;b or admins.&lt;/p&gt;
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceUpdateMercerStandingsPartnerRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesMercerStandingsMercerStandingDetailsModel>;
  public updateMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceUpdateMercerStandingsPartnerRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesMercerStandingsMercerStandingDetailsModel>>;
  public updateMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceUpdateMercerStandingsPartnerRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesMercerStandingsMercerStandingDetailsModel>>;
  public updateMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceUpdateMercerStandingsPartnerRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error('Required parameter employeeId was null or undefined when calling updateMercerStandingsPartner.');
    }
    const employeesMercerStandingsUpdateMercerStandingModel =
      requestParameters?.employeesMercerStandingsUpdateMercerStandingModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/mercer-standing/partner/api/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmployeesMercerStandingsMercerStandingDetailsModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employeesMercerStandingsUpdateMercerStandingModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Check whether the position class or job code is the same or higher than that of the line manager
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public validateMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceValidateMercerStandingsPartnerRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesMercerStandingsValidationMercerStandingValidationResponseModel>;
  public validateMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceValidateMercerStandingsPartnerRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesMercerStandingsValidationMercerStandingValidationResponseModel>>;
  public validateMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceValidateMercerStandingsPartnerRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesMercerStandingsValidationMercerStandingValidationResponseModel>>;
  public validateMercerStandingsPartner(
    requestParameters?: MercerStandingPartnerServiceValidateMercerStandingsPartnerRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error(
        'Required parameter employeeId was null or undefined when calling validateMercerStandingsPartner.'
      );
    }
    const employeesMercerStandingsValidationValidateMercerStandingInputModel =
      requestParameters?.employeesMercerStandingsValidationValidateMercerStandingInputModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/mercer-standing/partner/api/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/validate`;
    return this.httpClient.request<EmployeesMercerStandingsValidationMercerStandingValidationResponseModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employeesMercerStandingsValidationValidateMercerStandingInputModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }
}
